var map = {
	"./aws.png": "ffc1",
	"./confluent.png": "5dc0",
	"./hkcs.png": "af3d",
	"./hkstpsaa.png": "f58ea",
	"./new-relic.png": "e2fc",
	"./openapihub.png": "ca48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1eb6";